import { render, staticRenderFns } from "./FormInputGeneric.vue?vue&type=template&id=15ce2a68"
import script from "./FormInputGeneric.vue?vue&type=script&lang=js"
export * from "./FormInputGeneric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports